module.exports = __webpack_public_path__ + "static/img/wj.0e6f9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wj.png
// module id = qqmd
// module chunks = 0